<ng-container *ngIf="newItemUrl$|async as newItemUrl">
  <a class="bp-menu__link" (click)="verifyLink(newItemUrl)">
    <span class="fas fa-plus-circle"></span>
    {{'newItem' | cbsLabel}}
  </a>
</ng-container>

